<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    :width="size"
    :height="size"
    viewBox="0 0 18 19"
    class="svg-icon"
  >
    <g :fill="color" fill-rule="nonzero">
      <path
        d="M12.574 11.333c.42 0 .76.299.76.667 0 .368-.34.667-.76.667H6.093c-.42 0-.76-.299-.76-.667 0-.368.34-.667.76-.667zm0-4c.42 0 .76.299.76.667 0 .368-.34.667-.76.667H6.093c-.42 0-.76-.299-.76-.667 0-.368.34-.667.76-.667zm0-4c.42 0 .76.299.76.667 0 .368-.34.667-.76.667H6.093c-.42 0-.76-.299-.76-.667 0-.368.34-.667.76-.667z"
      />
      <circle cx="3.333" cy="4" r="1" fill="#000" />
      <circle cx="3.333" cy="8" r="1" fill="#000" />
      <circle cx="3.333" cy="12" r="1" fill="#000" />
    </g>
  </svg>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  name: "icon-menu",
  components: {},
})
export class IconMenu extends Vue {
  @Prop({ default: 26 }) public size!: number;
  @Prop({ default: "#ffffff" }) public color!: string;

  constructor() {
    super();
  }
}
export default IconMenu;
</script>
